import { IBusinessOperation } from '@Domains/Progress';
import { Typography } from '@mui/material';
import { progressNatureOfBusinessOperationsData } from '../../utils';
import ProgressBarDetails from './ProgressBarDetails';

type BusinessOperationProgressProps = {
  businessOperation: IBusinessOperation;
  reportId?: number;
  isPublished: boolean;
};

const BusinessOperationProgress = ({
  businessOperation,
  reportId,
  isPublished,
}: BusinessOperationProgressProps) => {
  return (
    <>
      <Typography variant="subtitle2" p={1}>
        2. ขั้นตอนกรอกข้อมูล Corporate Value Up
      </Typography>
      <ProgressBarDetails
        title={'ลักษณะการประกอบธุรกิจ'}
        progressData={progressNatureOfBusinessOperationsData(businessOperation)}
        id={reportId}
        isPublished={isPublished}
      />
    </>
  );
};

export default BusinessOperationProgress;
